var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center mb-2 mx-2",attrs:{"id":(_vm.details.text.includes('Task was completed by') ||
      _vm.details.text.includes('Task was reopened by')) &&
    _vm.details.is_log == true
      ? 'chip-green'
      : 'chip-purple'}},[_c('v-chip',{staticClass:"font-italic font-weight-bold justify-center align-center d-flex px-3",class:[
      !_vm.$vuetify.breakpoint.xs
        ? _vm.details.text.includes('Reminder of due date on') &&
          _vm.details.is_log == true
          ? 'reminder-task-log-color font-size-10'
          : (_vm.details.text.includes('Task was completed by') ||
              _vm.details.text.includes('Task was reopened by')) &&
            _vm.details.is_log == true
          ? 'complete-task-log-color font-size-10'
          : 'dusty-purple-text font-size-10'
        : _vm.details.text.includes('Reminder of due date on') &&
          _vm.details.is_log == true
        ? 'reminder-task-log-color font-size-8'
        : (_vm.details.text.includes('Task was completed by') ||
            _vm.details.text.includes('Task was reopened by')) &&
          _vm.details.is_log == true
        ? 'complete-task-log-color font-size-8'
        : 'dusty-purple-text font-size-8',
    ],staticStyle:{"width":"100% !important"},attrs:{"color":_vm.details.text.includes('Reminder of due date on') &&
      _vm.details.is_log == true
        ? '#e4e4e4'
        : (_vm.details.text.includes('Task was completed by') ||
            _vm.details.text.includes('Task was reopened by')) &&
          _vm.details.is_log == true
        ? '#ddf6ee'
        : '#f6f5fc'}},[_c('span',{directives:[{name:"line-clamp",rawName:"v-line-clamp:50",value:(2),expression:"2",arg:"50"}],class:_vm.$vuetify.breakpoint.xs ? 'justify-center align-center d-flex' : '',style:((_vm.details.text.includes('Task was completed by') ||
          _vm.details.text.includes('Task was reopened by')) &&
        _vm.details.is_log == true
          ? ''
          : 'max-width:100% !important;')},[_vm._v(" "+_vm._s(_vm.details.text)+" "+_vm._s(_vm.showDate(_vm.details.created_at))+" ")]),_c('v-spacer'),(
        _vm.details.read_by.length &&
          _vm.details.text.includes('Reminder of due date on') &&
          _vm.details.is_log == true
      )?_c('div',{staticClass:"d-flex dark-purple-text",class:!_vm.$vuetify.breakpoint.xs ? 'ml-8' : 'ml-4'},[(_vm.getLoggedInUser.id == _vm.details.user.id)?_c('v-tooltip',{attrs:{"open-delay":"150","color":"#f3fafb","left":"","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('p',_vm._g({class:!_vm.$vuetify.breakpoint.xs
                ? 'sent-time-css2 justify-end'
                : 'sent-time-css-xs justify-end'},on),[_vm._v(" Seen By ")])]}}],null,false,2307337300)},[(_vm.details.read_by.length != '')?_c('span',_vm._l((_vm.details.read_by),function(user,index){return _c('div',{key:index,staticClass:"title-text d-block text-capitalize"},[_vm._v(" "+_vm._s(user)+" ")])}),0):_vm._e()]):_vm._e()],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }